import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-point-down': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M188.8 512c-45.1 0-83.2-38.1-83.2-83.2v-86.2c-6.9 1.4-14.4 2.2-22.4 2.2-47.9 0-83.2-35.1-83.2-92 0-45.3 48.5-57 78.8-75.7 12.4-7.7 23.3-17 33.3-25.9l0.1-0.1 0.1-0.1c17.5-15.3 23.7-23.2 23.7-30.2v-2.7c-5-5.7-8-13.5-8-22.1v-64c0-17.7 12.9-32 28.8-32h230.4c15.9 0 28.8 14.3 28.8 32v64c0 8.6-3 16.4-8 22.1v2.7c0 28.7 40 67.1 40 127.2v21.3c0 62.5-38.7 98.8-91.1 99.9-17.8 12.5-40.8 18.5-62.8 16-5.8 3-15.7 6.5-22.1 7.9v35.6c0 45.4-37.6 83.2-83.2 83.2zM188.8 464c19 0 35.2-16.2 35.2-35.2v-91c14.7 12.8 42.8 14.4 61-5 19.6 11.2 45.6 1.7 53.6-12.9 39.1 6.5 61.3-10.1 61.3-50.6v-21.3c0-45.5-35.9-77.2-39.7-120h-176.8c-3 25.2-21.2 43-39.6 59.1-12.6 11.3-25.3 21.7-39.9 30.8-23.4 14.5-56.1 26.1-56.1 34.9 0 23.4 8.8 44 35.2 44 35.2 0 53.1-26.4 70.4-26.4v158.4c0 18.4 16.5 35.2 35.2 35.2zM328 64c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-point-down.js
// module id = 1764
// module chunks = 0